// Mock data for Registan Tourism

export const services = [
  {
    id: 1,
    name: "Dubai Visa 14 Days",
    duration: "3-5 business days",
    price: "AED 350",
    description: "Tourist visa valid for 14 days from entry date",
    icon: "Plane"
  },
  {
    id: 2,
    name: "Dubai Visa 30 Days",
    subtitle: "Dubai Visa",
    duration: "3-5 business days",
    price: "AED 450",
    description: "Tourist visa valid for 30 days from entry date",
    icon: "Plane"
  },
  {
    id: 3,
    name: "Dubai Visa 60 Days",
    subtitle: "Dubai Visa",
    duration: "5-7 business days",
    price: "AED 850",
    description: "Long-term tourist visa valid for 60 days",
    icon: "Plane"
  },
  {
    id: 4,
    name: "Freelance Visa",
    subtitle: "Freelance Visa",
    duration: "7-10 business days",
    price: "AED 8,000",
    description: "Professional freelance work permit and visa",
    icon: "Briefcase"
  },
  {
    id: 5,
    name: "30 Days Visa Change",
    duration: "5 hours",
    price: "AED 600",
    description: "Express 30-day visa change service by car",
    icon: "RefreshCw",
    category: "Visa Change"
  },
  {
    id: 6,
    name: "60 Days Visa Change",
    duration: "5 hours",
    price: "AED 800",
    description: "Express 60-day visa change service by car",
    icon: "RefreshCw",
    category: "Visa Change"
  }
];

export const nationalities = [
  "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Argentina", "Armenia", "Australia",
  "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium",
  "Belize", "Benin", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei",
  "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde",
  "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo", "Costa Rica",
  "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic",
  "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Fiji",
  "Finland", "France", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Greece", "Grenada",
  "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras", "Hungary", "Iceland",
  "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy", "Jamaica", "Japan", "Jordan",
  "Kazakhstan", "Kenya", "Kiribati", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho",
  "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Madagascar", "Malawi", "Malaysia",
  "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia",
  "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique", "Myanmar", "Namibia",
  "Nauru", "Nepal", "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Korea",
  "North Macedonia", "Norway", "Oman", "Pakistan", "Palau", "Palestine", "Panama", "Papua New Guinea",
  "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Qatar", "Romania", "Russia", "Rwanda",
  "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa", "San Marino",
  "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone",
  "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Korea",
  "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname", "Sweden", "Switzerland", "Syria",
  "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tonga", "Trinidad and Tobago",
  "Tunisia", "Turkey", "Turkmenistan", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates",
  "United Kingdom", "United States", "Uruguay", "Uzbekistan", "Vanuatu", "Vatican City", "Venezuela",
  "Vietnam", "Yemen", "Zambia", "Zimbabwe"
];

export const team = [
  {
    id: 1,
    name: "Ramiz Magdiev",
    role: "Manager",
    initial: "R",
    email: "ramiz@registantourism.ae",
    phone: "+971 54 450 00 00",
    location: "Dubai, United Arab Emirates",
    instagram: "https://instagram.com/registantourism",
    tiktok: "https://tiktok.com/@registantourism",
    bio: "Experienced tourism manager specializing in visa services and travel documentation. Helping clients navigate Dubai visa requirements for over 8 years."
  },
  {
    id: 2,
    name: "Parviz Magdiev",
    role: "Manager / Visa Consultant",
    initial: "P",
    email: "parviz@registantourism.ae",
    phone: "+971 54 450 00 01",
    location: "Dubai, United Arab Emirates",
    instagram: "https://instagram.com/registantourism",
    tiktok: "https://tiktok.com/@registantourism",
    bio: "Professional visa consultant with expertise in freelance visas and corporate documentation. Committed to providing fast and reliable visa solutions."
  }
];

export const companyInfo = {
  name: "Registan Tourism",
  phone: "+971 56 913 07 07",
  email: "support@registantours.com",
  hours: {
    status: "Open",
    closingTime: "5 PM",
    schedule: "Monday - Saturday: 9 AM - 5 PM\nSunday: Closed"
  },
  bookingPolicy: "Booking confirmation within 24 hours. Payment required before processing."
};

export const galleryImages = [
  {
    id: 1,
    url: "https://images.unsplash.com/photo-1576159470850-494c8b17aca0?q=85",
    alt: "Dubai Desert Safari"
  },
  {
    id: 2,
    url: "https://images.unsplash.com/photo-1613227835461-f0d182ac824d?q=85",
    alt: "Desert Tourism"
  },
  {
    id: 3,
    url: "https://images.unsplash.com/photo-1520440718111-45fe694b330a?q=85",
    alt: "Dubai Landscape"
  }
];

export const reviews = [
  {
    id: 1,
    author: "Ahmed Al-Mansoori",
    rating: 5,
    text: "Excellent service! Got my visa processed quickly and professionally.",
    date: "2 weeks ago"
  },
  {
    id: 2,
    author: "Sarah Johnson",
    rating: 5,
    text: "Very helpful team. Made the visa process so easy and stress-free.",
    date: "1 month ago"
  },
  {
    id: 3,
    author: "Mohammed Hassan",
    rating: 5,
    text: "Professional and reliable service. Highly recommended!",
    date: "1 month ago"
  }
];
